// Copyright 2025, University of Maryland, All Rights Reserved
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui'

interface YearSelectProps {
  value: number
  onChange: (year: number) => void
}

export function YearSelect({ value, onChange }: YearSelectProps) {
  const currentYear = new Date().getFullYear()
  const years = [currentYear - 1, currentYear]

  return (
    <Select
      value={value.toString()}
      onValueChange={(v) => onChange(parseInt(v))}
    >
      <SelectTrigger
        aria-label="Year"
        className="h-auto gap-2 rounded-[9px] border-slate-200 bg-white px-3.5 py-[7px] text-[12.5px] font-[550] text-slate-900 shadow-[0_1px_2px_rgba(2,8,23,0.04)]"
      >
        <SelectValue placeholder="Select year" />
      </SelectTrigger>
      <SelectContent>
        {years.map((year) => (
          <SelectItem key={year} value={year.toString()}>
            {year}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
